import DataTable from 'components/DataTable';
import ListActionsWrapper from 'components/ListActionsWrapper';
import ListTabs from 'components/ListTabs';
import ListWrapper from 'components/ListWrapper';
import PageHeader from 'components/PageHeader';
import SearchInput from 'components/SearchInput';
import Typography from 'components/Typography';
import calendar from '../../DeliveryPlanner/icons/calendar.svg';
import styles from '../Settings.module.scss';
import useRoutes, {ACTIVE_STATUSES} from './useRoutes';
import Pagination from 'components/Pagination';
import DateTimePicker from 'components/DateTimePicker';
import Select from 'components/Select';
import {components} from 'react-select';
import {DataTableSchemaItem} from 'types';

const SCHEMA: DataTableSchemaItem[] = [
  {
    dataKey: 'number',
    header: 'Route ID',
  },
  {
    dataKey: 'route_deliveries_count',
    header: 'Delivered',
  },
  {
    dataKey: 'status',
    header: 'Route status',
    sortable: true,
  }, 
  {
    dataKey: 'created_at',
    header: 'Date & Time',
    sortable: true,
  },
  {
    dataKey: 'vehicle',
    header: 'Vehicle',
    sortable: true,
  },
  {
    dataKey: 'driver',
    header: 'Driver',
    sortable: true,
  },

  {
    dataKey: 'view',
    header: '',
  },
];

const tabs = [
  {title: 'All', value: ''},
  // {title: 'All', value: [ACTIVE_STATUSES, 'completed'].join(',')},
  {title: 'Active', value: ACTIVE_STATUSES},
  {title: 'Complete', value: 'completed'},
  {title: 'Skipped', value: 'cancelled'},
];

function Routes() {
  const {
    data,
    isLoading,
    activeTab,
    sortBy,
    sortOrder,
    onchangeTab,
    onSort,
    keyWord,
    setKeyWord,
    totalPages,
    pageSize,
    setPageSize,
    count,
    filter,
    setFilter,
    drivers,
    currentPage,
    setCurrentPage,
    handleViewDetails,
    totalDeliveries,
  } = useRoutes();

  return (
    <div className={styles.main_container}>
      <PageHeader>
        <Typography variant="h2">Routes</Typography>
        <Typography variant="h4" textAlign="right">
          Total Counts of Deliveries:{' '}
          {Number(totalDeliveries).toLocaleString('en-US') || 0}
        </Typography>
      </PageHeader>
      <ListWrapper>
        <ListTabs
          isSupportPage={true}
          tabs={tabs}
          activeTabValue={activeTab}
          onChange={onchangeTab}
        />
        <ListActionsWrapper className={styles.list_header}>
          <SearchInput
            className={styles.route_search_input}
            value={keyWord}
            onChange={(val) => {
              setKeyWord(val.target.value);
              sessionStorage.setItem(`search_history`, val.target.value);
            }}
            placeholder="Search"
          />
          <div>
            <DateTimePicker
              icon={calendar}
              selectsRange={true}
              showTimeSelect={false}
              dateFormat="MM/dd/yy E"
              className={styles.date_created}
              startDate={filter.dateCreated?.startDate}
              endDate={filter.dateCreated?.endDate}
              placeholder="Created Date"
              onChange={(data) => {
                setFilter((prev) => ({
                  ...prev,
                  dateCreated: {
                    startDate: data[0] || undefined,
                    endDate: data[1] || undefined,
                  },
                }));
              }}
            />
          </div>
          <Select
            className={styles.driver_select}
            placeholder="Select driver"
            value={filter.driver}
            isClearable
            onChange={(val) => {
              setFilter((pr) => ({
                ...pr,
                driver: val || undefined,
              }));
            }}
            components={{
              DropdownIndicator: (props) =>
                !filter.driver?.value ? (
                  <components.DropdownIndicator {...props} />
                ) : null,
            }}
            options={drivers.map((item) => {
              return {
                value: item.id,
                label: item.full_name,
              };
            })}
          />
        </ListActionsWrapper>
        <DataTable
          data={data}
          schema={SCHEMA}
          loading={isLoading}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onClick={handleViewDetails}
          onSort={onSort}
        />
        {!isLoading && (
          <Pagination
            pageSize={pageSize}
            count={count}
            setPageSize={setPageSize}
            basePath={'/history/routes'}
            page={currentPage}
            total={totalPages}
            setCurrentPage={setCurrentPage}
          />
        )}
      </ListWrapper>
    </div>
  );
}

export default Routes;
